import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartyConfetti = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "party-confetti" }),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "cls-1",
			cx: 11.531,
			cy: 12.469,
			rx: 2.625,
			ry: 5.25,
			transform: "translate(-5.44 11.806) rotate(-45)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M7.4,9.7.888,21.121a1.5,1.5,0,0,0,1.991,1.991L14.3,16.605"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.773,7.7a.375.375,0,0,1,0,.531"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.243,7.7a.375.375,0,0,1,.53,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.243,8.227a.377.377,0,0,1,0-.531"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.773,8.227a.375.375,0,0,1-.53,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M20.016,3.454a.374.374,0,0,1,0,.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M19.486,3.454a.374.374,0,0,1,.53,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M19.486,3.984a.374.374,0,0,1,0-.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M20.016,3.984a.375.375,0,0,1-.53,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M20.016,14.06a.375.375,0,0,1,0,.531"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M19.486,14.06a.375.375,0,0,1,.53,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M19.486,14.591a.375.375,0,0,1,0-.531"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M20.016,14.591a.375.375,0,0,1-.53,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M8.349,4.514a.377.377,0,0,1,0,.531"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M7.819,4.514a.375.375,0,0,1,.53,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M7.819,5.045a.375.375,0,0,1,0-.531"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M8.349,5.045a.375.375,0,0,1-.53,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M12.857.75a13.836,13.836,0,0,1-.531,5.62"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 16.569,
			y1: 2.128,
			x2: 16.039,
			y2: 4.779
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M23.25,11.143a13.836,13.836,0,0,0-5.62.531"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 21.872,
			y1: 7.431,
			x2: 19.221,
			y2: 7.961
		})
	]
});
export default SvgPartyConfetti;
